/* istanbul ignore file */
import { onError } from '@apollo/client/link/error';
import { clearCredential } from 'common/auth/credential';

const onUnauthorized = () => {
  clearCredential();
  window.location.assign(window.location.href);
};

const unauthorizedErrorLink = onError(({ graphQLErrors }) => {
  if (!graphQLErrors) {
    return;
  }

  for (const error of graphQLErrors) {
    if (
      error?.extensions?.code === 'UNAUTHENTICATED' ||
      error?.extensions?.code === 'UNAUTHORIZED'
    ) {
      onUnauthorized();
      break;
    }
  }
});

export default unauthorizedErrorLink;
